import React, { useEffect, useState } from "react";
import axios from 'axios';
import AvatarUpload from "./UploadAvatar";
import { useSelector } from "react-redux";



const Profile = () => {
    const [showStatus, setShowStatus] = useState(false);
    const { apiUrl } = useSelector(state => state.api);

    let [changeInfoUser, setChangeInfoUser] = useState({
        user_id: "",
        user_name: "",
        user_phone: "",
        user_email: "",
        user_address: "",
        user_city: "",
        user_state: "",
        user_avatar: ""
    });

    const [currentInfoUser, setCurrentInfoUser] = useState({
        user_id: "",
        user_name: "",
        user_phone: "",
        user_email: "",
        user_address: "",
        user_city: "",
        user_state: "",
        user_avatar: ""
    });

    useEffect(() => {
        const findInfo = async () => {
            try {
                const response = await axios.get(`${apiUrl}/myaccount`, {
                    headers: { token: localStorage.token },
                })
                const parseRes = await response.data;
                const { user_password, user_id, ...rest } = parseRes;
                setCurrentInfoUser({ ...rest });
                setChangeInfoUser({ ...rest });
                // setChangeInfoUser({
                //     ...changeInfoUser,
                //     user_name: parseRes.user_name,
                //     user_email: parseRes.user_email,
                //     user_id: parseRes.user_id,
                //     user_phone: parseRes.user_phone,
                //     user_address: parseRes.user_address,
                //     user_city: parseRes.user_city,
                //     user_state: parseRes.user_state,
                //     user_avatar: parseRes.user_avatar,
                // });

            } catch (err) {
                console.error(err.message);
            }
        }

        findInfo();
    }, [apiUrl]);

    const changeInfo = async (e) => {
        e.preventDefault()
        const data = { ...changeInfoUser };
        try {
            const isEqual = await Object.values(data).every((value, index) => value === Object.values(currentInfoUser)[index]);
            if (!isEqual) {
                await axios.put(`${apiUrl}/myaccount/profile`, data, {
                    headers: { token: localStorage.getItem('token') }
                });
                setShowStatus("Information has changed!");
                setTimeout(() => window.location.reload(), 1000);
            } else {
                setShowStatus("Information does not change!");
                setTimeout(() => setShowStatus(true), 3000);
            }

        } catch (err) {
            console.error(err.message);

        }
    }

    const handleChangeInfoUser = (event) => {
        setChangeInfoUser({
            ...changeInfoUser,
            [event.target.name]: event.target.value,
        });
    };

    return (
        <div className="col-md-10 bg-light p-2">
            <div className="row ">

                <div class="col-md-6  text-center">
                    <form onSubmit={(e) => changeInfo(e)}>
                        <div class="row">
                            <div class="col-2 col-md-2 p-2 text-end">
                                <label for="name" class="form-label">Name:</label>
                            </div>
                            <div class="col-10 col-md-9">
                                <input type="text" class="form-control" id="name" name="user_name"
                                    value={changeInfoUser.user_name}
                                    onChange={handleChangeInfoUser}
                                    required
                                />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 col-md-2 p-2 text-end">
                                <label for="email" class="form-label">Email:</label>
                            </div>
                            <div class="col-10 col-md-9">
                                <input type="email" class="form-control" id="email" name="user_email"
                                    value={changeInfoUser.user_email}
                                    onChange={handleChangeInfoUser}
                                    required

                                />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 col-md-2 p-2 text-end">
                                <label for="phone" class="form-label">Phone:</label>
                            </div>
                            <div class="col-10 col-md-9">
                                <input type="tel" class="form-control" id="phone" name="user_phone"
                                    value={changeInfoUser.user_phone}
                                    onChange={handleChangeInfoUser}
                                    required />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 col-md-2 p-2 text-end">
                                <label for="address" class="form-label">Address:</label>
                            </div>
                            <div class="col-10 col-md-9">
                                <input class="form-control" id="address" name="user_address"
                                    value={changeInfoUser.user_address}
                                    onChange={handleChangeInfoUser}
                                    required
                                ></input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 col-md-2 p-2 text-end">
                                <label for="address" class="form-label">City:</label>
                            </div>
                            <div class="col-10 col-md-9">
                                <select class="form-select" id="inputCity" name="user_city"
                                    value={changeInfoUser.user_city}
                                    onChange={handleChangeInfoUser}
                                    required
                                >
                                    <option selected>Select your city</option>
                                    <option value="new-york">New York</option>
                                    <option value="los-angeles">Los Angeles</option>
                                    <option value="chicago">Chicago</option>
                                    <option value="houston">Houston</option>
                                    <option value="philadelphia">Philadelphia</option>
                                    <option value="miami">Miami</option>
                                    {/* <!-- Add more options here --> */}
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 col-md-2 p-2 text-end">
                                <label for="address" class="form-label">State:</label>
                            </div>
                            <div class="col-10 col-md-9">
                                <select class="form-select" id="inputState" name="user_state"
                                    onChange={handleChangeInfoUser}
                                    required
                                    value={changeInfoUser.user_state}

                                >
                                    <option selected>Select your state</option>
                                    <option value="Alabama">Alabama</option>
                                    <option value="Alaska">Alaska</option>
                                    <option value="Arizona">Arizona</option>
                                    {/* <!-- Add more options here --> */}
                                </select>
                            </div>
                        </div>
                        <div className="col-11 d-flex justify-content-end m-2">

                            <button type="submit" className="btn btn-primary">Save</button>
                        </div>
                        {showStatus && <div class="uploadStatus">{showStatus}</div>}

                    </form>
                </div>
                <div class="col-md-6  text-center p-4 border-start border-5">
                    <AvatarUpload changeInfoUser={changeInfoUser} />

                </div>
            </div>
        </div>
    )
}
export default Profile;